import { isBNBLLEHotelItem, isFlightItem } from './checkoutUtils'

/**
 * Lightweight prepareItem helper extracted to avoid circular dependencies.
 * Adjusts flight items to include required otherFees for svc-cart.
 */
export function prepareItem<T extends App.Checkout.AnyItem>(item: T): T {
  if (isFlightItem(item)) {
    if (!item.otherFees) {
      return {
        ...item,
        otherFees: {
          flightAtolFee: 0,
          flightBookingFee: 0,
          flightCreditFee: 0,
          flightServiceFee: 0,
        },
      }
    }
  }

  // BNBL LE Hotel items are filtered elsewhere; keep parity with original behavior
  if (isBNBLLEHotelItem(item)) {
    return item
  }

  return item
}

export default prepareItem
